




















































































import {
  Component,
  Emit,
  Inject,
  Model,
  Prop,
  Provide,
  Vue,
  Watch
} from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import ScrollView from "@/components/scroll/flipScroll.vue";
import PopGallery from "@/components/popGallery/popGallery.vue";
import Button from "@/components/button/Button.vue";
import * as types from "@/store/constants/types";
import NumUtils from "@/utils/numUtils";
import BakcPress from "@/utils/backPress";
import { ACTION_SHEET_KEY } from "@/utils/backPress";
@Component({
  components: {
    Button,
    PopGallery,
    ScrollView
  }
})
export default class InsUserPopGallery extends Vue {
  @Getter(types.GETTER_CURRENT_INS_USER_INFO)
  private currentUserInfo: any;
  @Getter(types.GETTER_INS_USER_INFO_BY_ID)
  private getUserInfoById: any;
  @Getter(types.GETTER_USER_LIST)
  private userList: any;
  @Getter(types.GETTER_SEARCH_LITE_MODE)
  private searchLiteMode: any;
  @Action(types.ROUTER_PUSH)
  private routerPush: any;
  @Mutation(types.CHANGE_CURRENT_USER)
  private changeCurrentUser: any;
  @Mutation(types.LITE_SEARCH_POP_SHOW)
  private liteSearchPopShow: any;
  @Prop({ default: false })
  private value?: boolean;

  private popShow: boolean = false;

  private contentHeight: number = 0;
  private itemHeight: number = 96;
  private buttonWrappeHeight: string = "auto";

  get format() {
    return NumUtils.format;
  }

  get userListLength() {
    return this.userList.length;
  }

  private followersCount(item: any) {
    return this.getUserInfoById(item.userId) &&
      this.getUserInfoById(item.userId).dataStatus === "ready"
      ? this.format(
          this.getUserInfoById(item.userId).insUserInfo.follower_count
        )
      : false;
  }

  @Watch("value", { immediate: true })
  private changePop(val: boolean, oldVal: boolean) {
    this.popShow = val;
  }

  @Watch("popShow", { immediate: true })
  private change(val: boolean, oldVal: boolean) {
    this.$emit("input", val);

    if (val) {
      BakcPress.listen({
        key: ACTION_SHEET_KEY,
        fn: () => {
          this.$emit("input", false);
        }
      });
    } else {
      BakcPress.destroy(ACTION_SHEET_KEY);
    }
  }

  @Watch("userListLength", { immediate: true })
  private userListchange(val: number, oldVal: number) {
    this.contentHeight = this.itemHeight * val;
  }

  // 改成类似于同步的方式，必须等待切换成功之后，才关闭popShow
  private async clickItem(item: any, index: number) {
    await this.changeCurrentUser(item.userId);
    this.popShow = false;
    this.$emit("clickItem", {
      item,
      index
    });
  }

  private clickLogin() {
    this.routerPush({
      name: "Login",
      params: {
        routerTransition: "up"
      }
    });
    this.popShow = false;
  }

  private clickLiteSearch() {
    this.popShow = false;
    this.liteSearchPopShow(true);
  }

  private clickSearch() {
    this.routerPush({
      name: "SearchUser",
      params: {
        routerTransition: "up"
      }
    });
    this.popShow = false;
  }
}
